export enum Collections {
    assessments = "assessments",
    userProfiles = "user-profile",
    courses = "courses",
    enrolments = "enrolments"
}
